export default __webpack_public_path__ + "static/media/discord.eb70b08f.svg";